import * as Yup from 'yup';
import { datetimeFromUTC } from 'utils/dayjs';

const dateRegexp = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

export default Yup.object().shape({
    customerName: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema.required('Заполните поле')}),
    customerSurname: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema
        .required('Заполните поле')}),
    customerEmail: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema.email('Неверный формат email')
        .required( 'Заполните поле' )}),
    // customerEmailConfirmation: Yup.string().when("customerEmail", {
    //     is: val => val && val.length > 0,
    //     then: Yup.string()
    //         .oneOf([Yup.ref("customerEmail")], "Email должны совпадать")
    //         .required('Обязательное поле')
    // }),
    customerBirthday: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema
            .nullable()
            .required('Заполните поле')
            .test('customerBirthday', 'Неверный формат даты', function (value) {
                if (!value) return false;
                return dateRegexp.test(datetimeFromUTC(value, true).date)
            }),
    }),
    address: Yup.string()
        .when(['delivery', 'cdekDeliveryType'], {
            is: (delivery, cdekDeliveryType) => delivery === 'cdek' && cdekDeliveryType === 'courier',
            then: fieldSchema => fieldSchema.required('Заполните поле')
        }),
    acceptConditions: Yup.boolean()
        .required('Нужно согласие на обработку персональных данных')
        .oneOf([true], 'Нужно согласие на обработку персональных данных'),
    cdekDeliveryType: Yup
        .string()
        .nullable()
        .when('delivery', {
            is: 'cdek',
            then: fieldSchema => fieldSchema
                .nullable()
                .required('Выберите пункт выдачи или доставку курьером с помощью виджета СДЭК')
        }),
});
